import { C, F, S } from "../../../../../CRM/frontend/src/design/tokens";

export default function PlaceholderPage({ title }) {
  return (
    <div style={{ padding: S.xxxl, height: "100%", overflow: "auto" }}>
      <h1 style={{ fontSize: F.h1, fontWeight: F.semibold, color: C.textPrimary, margin: 0 }}>
        {title}
      </h1>
    </div>
  );
}
